/* eslint-disable react/jsx-pascal-case */
import axios from "axios";
import { ChangeEvent, useEffect, useRef, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import io, { Socket } from "socket.io-client";
import styled from "styled-components";
import Layout_user from "../../../Component/UI/Layout_user";
import url from "../../../Component/server";
import { Icon, RowView } from "../../../Component/style/common_style";
import { amountFormat } from "../../../Component/tool/Tools";
import ChatComponent from "../../Chat/ChatComponent";
import Buy_Modal from "./modal/Buy_Modal";
import Delivery_Info_Modal from "./modal/Delivery_Info_Modal";
import Item_List_Modal from "./modal/Item_List_Modal";
import Notice_Modal from "./modal/Notice_Modal";
import Live_Component from "./Live_Component";
import { useToken } from "../../../Component/Context/useToken";
import Block from "./modal/Block";
import { fontStyles } from "../../../Component/style/common_font";
import api from "../../../Component/axios_Interceptor/api";

interface BuyBtnProps {
  $count: number;
}
interface VolumeProps {
  value: number;
}
interface ChatComponentRef {
  sendMessage: () => void;
}

export type live_info_type = {
  seq: number;
  live_start: string;
  live_finish: string;
  live_limit: number;
  live_title: string;
  live_img: string | null;
  live_status: string;
  crt_dt: string;
  send_check: string;
  start_dt: string;
  channel_name: string;
  store_seq: number;
  secret_yn: string;
};
type live_notice_type = {
  seq: number;
  live_seq: number;
  type: string;
  title: string | null;
  content: string;
  crt_dt: string;
};
type props_data_type = {
  seq: number;
  live_seq: number;
  name: string;
  price: number;
  option_check: string;
  init_cnt: number;
  current_cnt: number;
  product_status: string;
  product_num: number | null;
  unique_option1: string[];
  unique_option2: string[];
};

const Live = () => {
  const Navigate = useNavigate();
  const { userinfoReturn } = useToken();
  const { state } = useLocation();
  const { seq } = useParams();

  // 차단 팝업
  const [blockModal, setBlockModal] = useState(false);
  const handleBlockModal = () => {
    setBlockModal(!blockModal);
  };

  const get_user_info = async () => {
    const res = await api.get(url.Communication_url.user_info);
  };
  useEffect(() => {
    get_user_info();
  }, [blockModal]);

  const [BuyModal, setBuyModal] = useState(false);
  const openBuy = () => setBuyModal(!BuyModal);
  const [NoticeModal, setNoticeModal] = useState(false);
  const openNotice = () => setNoticeModal(!NoticeModal);
  const [DeliveryInfoModal, setDeliveryInfoModal] = useState(false);
  const openDeliveryInfo = () => setDeliveryInfoModal(!DeliveryInfoModal);
  const [ItemListModal, setItemListModal] = useState(false);
  const openItemList = () => setItemListModal(!ItemListModal);

  const [data, set_Data] = useState<props_data_type>();
  //   {
  //   seq: 1,
  //   live_seq: 1,
  //   name: "테일스쿨 120 청바지 home",
  //   price: 12000,
  //   option_check: "y",
  //   init_cnt: 40,
  //   current_cnt: 26,
  //   product_status: "판매중",
  //   product_num: null,
  //   unique_option1: ["화이트", "흑청"],
  //   unique_option2: ["32", "34"],
  // }
  const [live_info, set_Live_Info] = useState<live_info_type>();
  const [live_notice, set_Live_Notice] = useState<live_notice_type>();
  const [live_time, set_Live_Time] = useState<string>("00:00:00");
  const [viewer_count, set_Viewer_Count] = useState<number>(0);
  const [mesage, set_Mesage] = useState<string>("");
  const [all_visible, set_All_Visible] = useState(true);
  const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent);

  const go_home = () => Navigate("/");

  const get_live_info = () => {
    axios
      .get(url.Communication_url.get_live_info, {
        params: {
          seq: seq,
        },
      })
      .then(function (response) {
        set_Live_Info(response.data);
        live_user_ban_check(response.data.seq);
      })
      .catch(function (error) {});
  };

  const live_user_ban_check = async (seq: string) => {
    const res = await api.post(url.Communication_url.live_user_ban_check, {
      seq: seq,
    });
    if (res.data === "y") setBlockModal(true);
  };

  useEffect(() => {
    // if (!state) {
    //   go_home();
    //   return;
    // }
    // 우클릭 금지
    const originalOnContextMenu = document.oncontextmenu;
    document.oncontextmenu = function () {
      return false;
    };
    seq !== "undefined" && get_live_info();

    return () => {
      document.oncontextmenu = originalOnContextMenu;
    };
  }, []);

  const titleRef = useRef<HTMLDivElement>(null);
  const [isScrollable, setIsScrollable] = useState(false);

  useEffect(() => {
    if (titleRef.current) {
      const parentWidth = titleRef.current.offsetWidth;
      const textWidth = titleRef.current.scrollWidth;

      // 텍스트가 부모 컨테이너보다 길 경우에만 스크롤 활성화
      setIsScrollable(textWidth > parentWidth);
    }
  }, [live_info?.live_title]);

  const chatRef = useRef<ChatComponentRef>(null); // Ref 타입을 명시

  const handleSendMessage = () => {
    if (chatRef.current) {
      if (mesage.length <= 100) {
        chatRef.current.sendMessage(); // ChatComponent의 sendMessage 호출

        set_Mesage("");
      } else {
        alert("입력 가능한 글자 수는 최대 100자입니다.");
      }
    }
  };

  // 볼륨조절
  const [volume, setVolume] = useState<number>(100); // 초기 볼륨 값
  const [volume_on, set_Volume_On] = useState<boolean>(false);
  const Volume_OnOff = () => set_Volume_On(!volume_on);

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) =>
    setVolume(Number(event.target.value));

  // 소켓
  const SOCKET_SERVER_URL = "https://fanbird.live/live";
  const [socket, setSocket] = useState<Socket | null>(null);

  useEffect(() => {
    if (seq === "undefined") {
      alert("방송정보가 없습니다.");
      Navigate("/", { replace: true });
    }
    if (live_info) {
      seq !== "undefined" && is_visable_product();
      // 소켓 연결을 초기화합니다.
      const newSocket = io(SOCKET_SERVER_URL, {
        path: "/socket.io", // nginx에서 location /live/로 프록시 중이므로 필요
        transports: ["websocket"], // polling을 비활성화하고 WebSocket만 사용
      });
      setSocket(newSocket);

      newSocket.on("connect", () => {
        newSocket.emit("join-channel", { channelId: live_info?.channel_name });
      });

      // 메시지를 수신할 때마다 state를 업데이트합니다.
      newSocket.on("Duration Time", (item: string) => {
        // console.log("Duration Time : ", item);
        set_Live_Time(item);
      });
      newSocket.on("Viewer Count", (item: string) => {
        // console.log("Viewer Count : ", item);
        set_Viewer_Count(Number(item));
      });
      newSocket.on("Live Notice", (item: live_notice_type[]) => {
        // console.log("Live Notice : ", item);
        set_Live_Notice(item[0]);
      });
      newSocket.on("Stock", (item: props_data_type) => {
        // console.log("Stock : ", item);
        set_Data(item);
        setBuyModal(false);
      });
      newSocket.on("Stock Over", (item: props_data_type) => {
        // console.log("Stock Over: ", item);
        if (item.product_status === "판매노출") {
          set_Data(item);
          setBuyModal(false);
        }
      });
      const Blocked_Id = async () => {
        const userinfo = await userinfoReturn();

        newSocket.on("Blocked Id", (item: string) => {
          // console.log(item);
          item === userinfo.userid && setBlockModal(true);
        });
      };
      Blocked_Id();

      seq !== "undefined" && get_live_notice();
      // 컴포넌트가 언마운트될 때 소켓 연결을 정리합니다.
      return () => {
        newSocket.disconnect();
      };
    }
  }, [live_info]);

  const get_live_notice = () => {
    axios
      .get(url.Communication_url.get_live_notice, {
        params: {
          seq: seq,
          type: "ln",
        },
      })
      .then(function (response) {
        set_Live_Notice(response.data[0]);
      })
      .catch(function (error) {
        // console.log("get-live-info error", error);
      });
  };
  const is_visable_product = () => {
    axios
      .get(url.Communication_url.is_visable_product, {
        params: { live_seq: seq },
      })
      .then(function (response) {
        response.data !== "상품없음" && set_Data(response.data);
      })
      .catch(function (error) {
        // console.log("get-live-info error", error);
      });
  };

  return (
    <Layout_user isScroll="none">
      <Box translate="no">
        <Streaming_Box>
          {live_time !== "00:00:00" && live_info ? (
            <Live_Component
              volume={volume}
              set_All_Visible={set_All_Visible}
              all_visible={all_visible}
              live_info={live_info}
            />
          ) : (
            <Waiting_Text>방송 준비중입니다.</Waiting_Text>
          )}
          {all_visible && live_notice && live_notice.content !== " " && (
            <Notice dangerouslySetInnerHTML={{ __html: live_notice.content }} />
          )}
          {all_visible && (
            <>
              <Status_Box>
                <div style={{ display: "flex" }}>
                  <Icon src={require("../../../Image/ic_live_red.png")} />
                  <Time_Box>
                    <Shadow_Icon
                      src={require("../../../Image/ic_time_white.png")}
                    />
                    &nbsp;{live_time}
                  </Time_Box>
                  <Viewer_Count_Box>
                    <Shadow_Icon
                      src={require("../../../Image/ic_viewer_white.png")}
                    />
                    &nbsp;{viewer_count}
                  </Viewer_Count_Box>
                </div>
                <Exit_Btn
                  onClick={go_home}
                  src={require("../../../Image/ic_x_white2.png")}
                />
              </Status_Box>
              <Title_Box>
                <Title ref={titleRef}>
                  <TitleText $isScrollable={isScrollable}>
                    {live_info?.live_title}
                  </TitleText>
                </Title>
              </Title_Box>
              {volume_on && (
                <Volume_Box>
                  <Volume
                    min="0"
                    max="100"
                    value={volume}
                    onChange={handleChange}
                  />
                </Volume_Box>
              )}
            </>
          )}
          {live_time !== "00:00:00" && (
            <Bottom_Box>
              <Bottom_Row>
                <Item_Chat_Box>
                  <Chat_Box
                    style={{
                      height:
                        data && data.product_status === "판매노출" ? 150 : 220,
                      maxHeight:
                        data && data.product_status === "판매노출" ? 150 : 220,
                    }}
                  >
                    {live_time !== "00:00:00" && (
                      <ChatComponent
                        ref={chatRef}
                        mesage={mesage}
                        all_visible={all_visible}
                        live_info={live_info!}
                      />
                    )}
                  </Chat_Box>
                  {data && data.product_status === "판매노출" && (
                    <Item_Box translate="no">
                      <Item_Data_Box translate="no">
                        <div>
                          {data.name.length > 12
                            ? `${data.name.slice(0, 12)}...`
                            : data.name}
                        </div>
                        <RowView
                          style={{ color: "#EA2922", width: "100%" }}
                          translate="no"
                        >
                          <div>{amountFormat(data.price)}원</div>
                          {data.product_num !== null &&
                            data.product_num !== undefined && (
                              <div
                                style={{ color: "#C6C6C6", fontSize: 14 }}
                                translate="no"
                              >
                                No.{data.product_num}
                              </div>
                            )}
                        </RowView>
                      </Item_Data_Box>
                      <Buy_Btn
                        as="button"
                        disabled={data.current_cnt === 0}
                        $count={data.current_cnt}
                        onClick={openBuy}
                        translate="no"
                      >
                        {data.current_cnt === 0 ? "품절" : "구매"}
                      </Buy_Btn>
                    </Item_Box>
                  )}
                </Item_Chat_Box>
                {all_visible && (
                  <Side_Btn_Box>
                    <Side_Btn
                      onClick={openNotice}
                      src={require("../../../Image/ic_notice_black.png")}
                    />
                    <span style={{ marginTop: 5 }}>공지사항</span>
                    {!isIOS && (
                      <>
                        <Side_Btn
                          onClick={Volume_OnOff}
                          src={require("../../../Image/ic_volume_black.png")}
                        />
                        <span style={{ marginTop: 5 }}>소리설정</span>
                      </>
                    )}

                    <Side_Btn
                      onClick={openDeliveryInfo}
                      src={require("../../../Image/ic_mypage_black.png")}
                    />
                    <span style={{ marginTop: 5 }}>구매정보</span>

                    <Side_Btn
                      onClick={openItemList}
                      src={require("../../../Image/ic_list_black.png")}
                    />
                    <span style={{ marginTop: 5 }}>상품목록</span>
                  </Side_Btn_Box>
                )}
              </Bottom_Row>
              {all_visible && (
                <Chat_Insert_Box>
                  <Chat_Insert>
                    <Insert_Text
                      value={mesage}
                      placeholder="메시지를 입력해주세요."
                      onChange={(e) => set_Mesage(e.target.value)}
                      onKeyDown={(e) => {
                        // 조합 중이면 무시
                        if (e.key === "Enter" && !e.nativeEvent.isComposing) {
                          handleSendMessage();
                        }
                      }}
                    />

                    <Send_Icon
                      src={require("../../../Image/ic_send_white.png")}
                      onClick={handleSendMessage}
                    />
                  </Chat_Insert>
                </Chat_Insert_Box>
              )}
            </Bottom_Box>
          )}

          <Buy_Modal
            visible={BuyModal}
            handleModal={setBuyModal}
            item={data}
            seq={Number(seq)}
            type="live"
          />
          <Notice_Modal
            visible={NoticeModal}
            handleModal={setNoticeModal}
            seq={Number(seq)}
          />
          <Delivery_Info_Modal
            visible={DeliveryInfoModal}
            handleModal={setDeliveryInfoModal}
            seq={Number(seq)}
          />
          <Item_List_Modal
            visible={ItemListModal}
            handleModal={setItemListModal}
            seq={Number(seq)}
          />
          <Block
            visible={blockModal}
            handleModal={handleBlockModal}
            ban_popup={
              "관리자에 의해 회원님의 이용이 일시중단됩니다.\n이용을 원할시 관리자에게 문의바랍니다."
            }
            isLogout={true}
          />
        </Streaming_Box>
      </Box>
    </Layout_user>
  );
};

export default Live;

const Box = styled.div`
  background-color: black;
  background-size: contain;
  height: 100%;
  display: flex;
  align-items: center;
`;

const Streaming_Box = styled.div`
  width: 100%;
  height: 100%;
  max-height: 1080px;
  /* background-color: #de9c9c; */
  position: relative;
  display: flex;
  flex-direction: column;
  overflow: hidden;
`;

const Title_Box = styled.div`
  width: 100%;
  align-items: flex-end;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  z-index: 1;
  padding: 8px 0px 14px 0px;
  overflow: hidden; /* Title이 박스를 넘지 않도록 설정 */
`;

const Title = styled.div`
  ${fontStyles.Bold};
  font-size: 20px;
  margin-left: 16px;
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.5); // 텍스트 그림자 추가
  white-space: nowrap;
  overflow: hidden; /* 텍스트가 박스를 넘지 않도록 설정 */
  position: relative; /* 내부 span의 위치를 기준으로 설정 */
`;

const TitleText = styled.span<{ $isScrollable: boolean }>`
  display: inline-block; /* 텍스트를 블록처럼 취급 */
  animation: ${({ $isScrollable }) =>
    $isScrollable
      ? "scrollText 10s linear infinite"
      : "none"}; /* 조건부 애니메이션 */

  @keyframes scrollText {
    0% {
      transform: translateX(0%); /* 텍스트가 오른쪽에서 시작 */
    }
    100% {
      transform: translateX(-80%); /* 텍스트가 왼쪽으로 이동 */
    }
  }
`;

const Exit_Btn = styled(Icon)`
  cursor: pointer;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  -webkit-user-drag: none;
  -khtml-user-drag: none;
  -moz-user-drag: none;
  -o-user-drag: none;
  &:active {
    opacity: 0.5; // 클릭 시 opacity 변화
  }
`;

const Status_Box = styled.div`
  z-index: 1;
  width: 100%;
  padding: 16px 16px 0px 16px;
  display: flex;
  align-items: center;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  -webkit-user-drag: none;
  -khtml-user-drag: none;
  -moz-user-drag: none;
  -o-user-drag: none;
  box-sizing: border-box;
  justify-content: space-between;
`;

const Time_Box = styled.div`
  margin-left: 8px;
  display: flex;
  font-family: var(--font-Pretendard-SemiBold);
  color: white;
  align-items: center;
  font-size: 16;
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.5); // 텍스트 그림자 추가
`;

const Viewer_Count_Box = styled.div`
  margin-left: 16px;
  display: flex;
  font-family: var(--font-Pretendard-SemiBold);
  color: white;
  align-items: center;
  font-size: 16;
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.5); // 텍스트 그림자 추가
`;

const Shadow_Icon = styled(Icon)`
  filter: drop-shadow(2px 2px 5px rgba(0, 0, 0, 0.5)); /* 그림자 적용 */
`;

const Notice = styled.div`
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2;
  top: 100px;
  border-radius: 8px;
  padding: 12px 16px;
  margin-left: 16px;
  line-height: 20px;
  font-size: 14px;
  max-width: 25%;
  max-height: 15rem;
  background-color: rgba(255, 255, 255, 0.8);
  color: black;
  white-space: pre-line;
  word-break: break-word;
  overflow-y: auto;
`;

const Bottom_Box = styled.div`
  display: flex;
  width: 100%;
  /* background-color: #a9a9a9; */
  height: 450px;
  margin-top: auto;
  flex-direction: column;
  position: relative;
  padding: 15px 15px 15px 15px;
  box-sizing: border-box;
  z-index: 1;
`;

const Chat_Insert_Box = styled.div`
  align-self: flex-end;
  height: 50px;
  width: 100%;
  align-items: center;
  justify-content: center;
  margin-top: auto;
`;

const Chat_Insert = styled.div`
  width: 100%;
  height: 48px;
  background-color: rgba(0, 0, 0, 0.6);
  padding: 0px 25px;
  border-width: 1px;
  border-style: solid;
  border-color: white;
  border-radius: 100px;
  align-items: center;
  display: flex;
  position: relative;
  box-sizing: border-box;
  justify-content: space-between;
`;

const Bottom_Row = styled(RowView)`
  flex: 1;
  margin-bottom: 15px;
`;

const Item_Chat_Box = styled.div`
  display: flex;
  height: 100%;
  flex: 1;
  flex-direction: column;
  margin-right: 18px;
  align-items: center;
  justify-content: flex-end;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  -webkit-user-drag: none;
  -khtml-user-drag: none;
  -moz-user-drag: none;
  -o-user-drag: none;
  box-sizing: border-box;
`;

const Chat_Box = styled.div`
  width: 100%;
  max-width: 100%;
  /* height: 150px;
  max-height: 150px; */
  flex: 1;
  display: flex;
  position: relative;
  box-sizing: border-box;
`;

const Item_Box = styled.div`
  width: 100%;
  height: 80px;
  box-sizing: border-box;
  margin-top: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  overflow: hidden;
`;

const Item_Data_Box = styled.div`
  background-color: white;
  color: black;
  flex: 7;
  flex-direction: column;
  display: flex;
  justify-content: space-between;
  box-sizing: border-box;
  padding: 18px 16px;
  height: 100%;
  font-size: 16px;
  font-family: var(--font-Pretendard-SemiBold);
`;

const Buy_Btn = styled.div<BuyBtnProps>`
  background: ${(props) =>
    props.$count === 0
      ? "linear-gradient(to bottom right, #F8F8F8,#F8F8F8)"
      : "linear-gradient(135deg, #7955F0, #3209B9)"};
  color: ${(props) => (props.$count === 0 ? "#8E8E8E" : "white")};
  flex: 3;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
  font-family: var(--font-Pretendard-Bold);
  border-width: 0px;
  cursor: pointer;
  &:disabled {
    cursor: not-allowed;
  }
  &:active {
    opacity: 0.5;
    &:disabled {
      opacity: 1;
    }
  }
`;

const Side_Btn_Box = styled.div`
  display: flex;
  position: relative;
  flex-direction: column;
  box-sizing: border-box;
  justify-content: flex-end;
  height: 100%;
  width: 50px;
  font-size: 14px;
  color: white;
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.5);
`;

const Side_Btn = styled(Icon)`
  margin-top: 16px;
  cursor: pointer;
  transition: opacity 0.1s ease;
  &:active {
    opacity: 0.5;
  }
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  -webkit-user-drag: none;
  -khtml-user-drag: none;
  -moz-user-drag: none;
  -o-user-drag: none;
`;

const Volume_Box = styled.div`
  z-index: 10;
  background-color: white;
  position: absolute;
  display: flex;
  right: 15px;
  top: 25%;
  width: 35px;
  height: 250px;
  justify-content: center;
  align-items: center;
  border-radius: 100px;
`;

const Volume = styled.input.attrs({ type: "range" })<VolumeProps>`
  -webkit-appearance: none;
  display: flex;
  position: absolute;
  width: 220px;
  height: 8px;
  background: transparent;
  border-radius: 5px;
  outline: none;
  transform: rotate(270deg);
  writing-mode: bt-lr;

  &::-webkit-slider-thumb {
    -webkit-appearance: none;
    appearance: none;
    width: 20px;
    height: 20px;
    border-radius: 50%;
    background: #e4e4e4;
    border: 6px solid white;
    cursor: pointer;
    transform: translateY(-6px);
    box-shadow: 0 0px 5px rgba(0, 0, 0, 0.5);
  }

  &::-webkit-slider-runnable-track {
    width: 100%;
    height: 8px;
    cursor: pointer;
    background: linear-gradient(
      to right,
      #3209b9 ${(props) => props.value}%,
      #e4e4e4 ${(props) => props.value}%
    );
    border-radius: 5px;
    position: relative;
  }
`;

const Send_Icon = styled(Shadow_Icon)`
  justify-self: flex-end;
  cursor: pointer;
  &:active {
    opacity: 0.5;
  }
`;

const Insert_Text = styled.input`
  outline: none;
  border: none;
  width: 100%;
  font-size: 16px;
  background-color: rgba(255, 255, 255, 0);
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.5); // 텍스트 그림자 추가
  color: white;
  &::placeholder {
    color: white;
  }
`;

const Waiting_Text = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  font-size: 25px;
  display: flex; /* Flexbox로 중앙 배치 */
  justify-content: center; /* 가로 중앙 정렬 */
  align-items: center; /* 세로 중앙 정렬 */
  color: lightgray;
  text-align: center;
`;
